import React from 'react'
import {Scrollbars} from 'react-custom-scrollbars';
import {isUndefined} from 'lodash'

const CustomScrollbars = (props) =>{

  const handleAboutToReachBottom = () => {
    // load more
    console.log('Reached Bottom!')
    if(!isUndefined(props.onReachedBottom)) props.onReachedBottom()
  }

  const handleUpdate = (values) => {
    const { scrollTop, scrollHeight, clientHeight } = values;
    const pad = 100; // 100px of the bottom
    // t will be greater than 1 if we are about to reach the bottom
    const t = ((scrollTop + pad) / (scrollHeight - clientHeight));
    if (t > 1) handleAboutToReachBottom();
  }

  return (
    <Scrollbars  {...props} 
      onUpdate={handleUpdate}
      autoHide
      renderTrackHorizontal={props => <div {...props}
        style={{display: 'none'}}
        className="track-horizontal"/>}
    />
  )
} 

export default CustomScrollbars;